import { render, staticRenderFns } from "./UpgradeBar.vue?vue&type=template&id=0f0ab603&"
import script from "./UpgradeBar.vue?vue&type=script&lang=js&"
export * from "./UpgradeBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./UpgradeBar.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports